import { useEffect, useState } from 'react';

// Chrome fires this once, early, often before anyone is logged in, so it has to be caught at load.
let deferredInstallPrompt = null;
const installPromptListeners = new Set();
window.addEventListener('beforeinstallprompt', event => {
  event.preventDefault();
  deferredInstallPrompt = event;
  installPromptListeners.forEach(listener => listener(event));
});

function useInstallPrompt() {
  const [installPrompt, setInstallPrompt] = useState(deferredInstallPrompt);

  useEffect(() => {
    installPromptListeners.add(setInstallPrompt);
    return () => installPromptListeners.delete(setInstallPrompt);
  }, []);

  // A prompt can only be shown once; Chrome fires a fresh event if the app is uninstalled later.
  const install = async () => {
    installPrompt.prompt();
    await installPrompt.userChoice;
    deferredInstallPrompt = null;
    installPromptListeners.forEach(listener => listener(null));
  };

  return { installPrompt, install };
}

export default useInstallPrompt;
